var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlternating = function SvgAlternating(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "495.3 320.9 200 200",
    enableBackground: "new 495.3 320.9 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.7,332.1l-8.3,2l-73.2,17.5l-3.7,0.9l1.1,3.7l21.4,71.9l2.4,8.1l4.2-7.3l14.3-24.7l15.4,8.8l3.7-6.3l-18.5-10.7 l-3.2-1.8l-1.8,3.1l-11.9,20.5l-17.9-60.1l61.2-14.6L563,363.6l-1.8,3.2l3.2,1.8l60.9,35l-6.9,11.9l6.3,3.6l8.7-15l1.8-3.2 l-3.2-1.8l-60.9-35l14.3-24.6L589.7,332.1L589.7,332.1z M578.7,401.1l-22.4,38.8l60.6,35l3.2,1.8l-1.8,3.2L601,509.6l85.5-20.5 l-25-84.2l-17.2,29.8l-1.8,3.2l-3.2-1.8L578.7,401.1L578.7,401.1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlternating, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alternating.ee16e53a.svg";
export { ForwardRef as ReactComponent };